// // // CaptchaComponent.jsx
// // import React, { useEffect, useState } from "react";
// // import { Box, Typography, Button } from "@mui/material";
// // import axios from "axios";
// // import { API_BASE_URL } from "../../config";

// // export const CaptchaComponent = ({ onChange, setCaptchaKey }) => {
// //   const [captchaText, setCaptchaText] = useState("");

// //   const fetchCaptcha = async () => {
// //     try {
// //       const { data } = await axios.get(`${API_BASE_URL}/auth/captcha/`);
// //       setCaptchaText(data.captcha_text);
// //       setCaptchaKey(data.captcha_key);
// //       onChange({ target: { name: "captcha_value", value: "" } }); // reset input
// //     } catch (error) {
// //       setCaptchaText("Failed to load captcha");
// //       setCaptchaKey("");
// //     }
// //   };

// //   useEffect(() => {
// //     fetchCaptcha();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   return (
// //     <Box>
// //       <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
// //         <Typography
// //           sx={{
// //             fontWeight: "bold",
// //             fontSize: "1.2rem",
// //             userSelect: "none",
// //             letterSpacing: 2,
// //             backgroundColor: "#f0f0f0",
// //             p: "4px 12px",
// //             borderRadius: "4px",
// //             fontFamily: "monospace",
// //           }}
// //         >
// //           {captchaText}
// //         </Typography>
// //         <Button size="small" variant="outlined" onClick={fetchCaptcha}>
// //           Refresh
// //         </Button>
// //       </Box>
// //       <Typography variant="body2" sx={{ mb: 0 }}>
// //         Enter Captcha
// //       </Typography>
// //     </Box>
// //   );
// // };


// import React, { useEffect, useState } from "react";
// import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
// import RefreshIcon from '@mui/icons-material/Refresh';
// import axios from "axios";
// import { API_BASE_URL } from "../../config";


// export const CaptchaComponent = ({ onChange, setCaptchaKey }) => {
//   const [captchaText, setCaptchaText] = useState("");
//   const [loading, setLoading] = useState(false);

//   const fetchCaptcha = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(`${API_BASE_URL}/auth/captcha/`);
//       setCaptchaText(data.captcha_text);
//       setCaptchaKey(data.captcha_key);
//       onChange({ target: { name: "captcha_value", value: "" } }); // reset input on refresh
//     } catch (error) {
//       setCaptchaText("Failed to load captcha");
//       setCaptchaKey("");
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchCaptcha();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <Box>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//         <Typography
//           sx={{
//             fontWeight: "bold",
//             fontSize: "1.4rem",
//             userSelect: "none",
//             letterSpacing: 4,
//             backgroundColor: "#e3f2fd",
//             color: "#1565c0",
//             p: "6px 16px",
//             borderRadius: "8px",
//             fontFamily: "'Courier New', Courier, monospace",
//             boxShadow: "0px 3px 8px rgba(21, 101, 192, 0.3)",
//             minWidth: "150px",
//             textAlign: "center",
//             textTransform: "uppercase",
//           }}
//         >
//           {captchaText}
//         </Typography>
//         <IconButton
//           size="small"
//           color="primary"
//           onClick={fetchCaptcha}
//           disabled={loading}
//           sx={{
//             border: "1.5px solid #1565c0",
//             "&:hover": {
//               backgroundColor: "#bbdefb",
//               borderColor: "#0d47a1",
//             },
//             boxShadow: "0px 2px 10px rgb(21 101 192 / 0.4)",
//           }}
//           aria-label="refresh captcha"
//         >
//           {loading ? (
//             <CircularProgress size={20} thickness={5} color="inherit" />
//           ) : (
//             <RefreshIcon fontSize="medium" />
//           )}
//         </IconButton>
//       </Box>
//       <Typography variant="body2" sx={{ mb: 0, fontWeight: 500, color: "#555" }}>
//         Enter Captcha
//       </Typography>
//     </Box>
//   );
// };



import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, CircularProgress } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from "axios";
import { API_BASE_URL } from "../../config";

export const CaptchaComponent = ({ onChange, setCaptchaKey }) => {
  const [captchaImage, setCaptchaImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const fetchCaptcha = async () => {
    setLoading(true);
    setFailed(false);
    try {
      const { data } = await axios.get(`${API_BASE_URL}/auth/captcha/`);
      setCaptchaImage(data.captcha_image);
      setCaptchaKey(data.captcha_key);
      onChange({ target: { name: "captcha_value", value: "" } }); // reset input on refresh
    } catch (error) {
      setFailed(true);
      setCaptchaKey("");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCaptcha();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Box
          sx={{
            minWidth: "180px",
            height: "60px",
            borderRadius: "8px",
            boxShadow: "0px 3px 8px rgba(21, 101, 192, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#e3f2fd",
          }}
        >
          {loading ? (
            <CircularProgress size={22} thickness={5} color="primary" />
          ) : failed ? (
            <Typography variant="caption" color="error">
              Failed to load captcha
            </Typography>
          ) : (
            <img
              src={`data:image/png;base64,${captchaImage}`}
              alt="captcha"
              style={{ height: "60px", borderRadius: "8px" }}
            />
          )}
        </Box>
        <IconButton
          size="small"
          color="primary"
          onClick={fetchCaptcha}
          disabled={loading}
          sx={{
            border: "1.5px solid #1565c0",
            "&:hover": {
              backgroundColor: "#bbdefb",
              borderColor: "#0d47a1",
            },
            boxShadow: "0px 2px 10px rgb(21 101 192 / 0.4)",
          }}
          aria-label="refresh captcha"
        >
          {loading ? (
            <CircularProgress size={20} thickness={5} color="inherit" />
          ) : (
            <RefreshIcon fontSize="medium" />
          )}
        </IconButton>
      </Box>
      <Typography variant="body2" sx={{ mb: 0, fontWeight: 500, color: "#555" }}>
        Enter Captcha
      </Typography>
    </Box>
  );
};